import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { TeamHqModal } from "./TeamHqModal";

/**
 * TeamPage — full-page `/teams/:team_id` route. Renders the existing
 * TeamHqModal content as a dedicated page. Close action navigates back
 * to the previous route (typically /dashboard) instead of just closing
 * the modal overlay.
 */
export function TeamPage({ onToast }) {
  const { team_id } = useParams();
  const navigate = useNavigate();
  // TeamHqModal is `open`-gated — we always render it open while the
  // route is active. Its close handler routes home so back-button + the
  // X button both behave like a page exit.
  const [open, setOpen] = useState(true);

  useEffect(() => { setOpen(true); }, [team_id]);

  return (
    <main className="page-z" data-testid="team-page">
      <TeamHqModal
        open={open}
        teamId={team_id}
        onClose={() => { setOpen(false); navigate(-1); }}
        onToast={onToast}
      />
    </main>
  );
}

export default TeamPage;
